import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { imgUrl } from "../../lib/api";

const INTERVAL = 5000;

export const HeroSlider = ({ slides, settings }) => {
  const [idx, setIdx] = useState(0);
  const defaultImg = imgUrl(settings?.hero_image, "/on_kapi_girisi.jpg");
  const items = slides.length ? slides : [{ id: null, title: settings?.hero_caption, image_path: settings?.hero_image }];

  useEffect(() => {
    if (items.length < 2) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), INTERVAL);
    return () => clearInterval(t);
  }, [items.length, idx]);

  const cur = items[idx % items.length];

  return (
    <div className="relative h-[52vh] min-h-[380px] lg:h-[600px] rounded-[2rem] overflow-hidden bg-[#13251C]" data-testid="hero-slider">
      {items.map((s, i) => (
        <img key={s.id || i} src={s.image_path ? imgUrl(s.image_path) : defaultImg} alt={s.title || "Başkent Sitesi"}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${i === idx ? "opacity-100" : "opacity-0"}`} />
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" aria-hidden="true" />
      <div className="absolute left-0 right-0 bottom-0 p-5 sm:p-8">
        {cur.id ? (
          <Link to={`/duyuru/${cur.id}`} className="group flex items-end justify-between gap-4" data-testid="hero-slide-link">
            <p className="text-white font-display text-lg sm:text-2xl lg:text-3xl font-semibold tracking-tight truncate" data-testid="hero-caption">{cur.title}</p>
            <span className="shrink-0 w-11 h-11 rounded-full bg-white/90 text-[#1B4332] flex items-center justify-center group-hover:bg-[#E07A5F] group-hover:text-white transition-colors">
              <ArrowUpRight size={20} />
            </span>
          </Link>
        ) : (
          <p className="text-white font-display text-lg sm:text-2xl lg:text-3xl font-semibold tracking-tight truncate" data-testid="hero-caption">{cur.title}</p>
        )}
        {items.length > 1 && (
          <div className="mt-4 flex gap-2" data-testid="hero-dots">
            {items.map((s, i) => (
              <button key={s.id || i} onClick={() => setIdx(i)} aria-label={`Haber ${i + 1}`} data-testid={`hero-dot-${i}`}
                className="relative h-1.5 flex-1 max-w-16 rounded-full bg-white/30 overflow-hidden">
                {i === idx && <span key={`p-${idx}`} className="absolute inset-0 bg-white slide-progress" />}
                {i < idx && <span className="absolute inset-0 bg-white/80" />}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
